import styled from "styled-components";

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`;

export default PaginationWrapper;
